module.exports = __webpack_public_path__ + "media/fonts/Matter-Heavy-418c5cf5975dd9a67e3c666ef4ac01bc.ttf";